// Selectors


import { RootState } from '../../store';

export const issuanceConfigFormSelector = (state: RootState) => state.issuanceConfigFormState
